import React, { Component } from 'react'
import MappingSexList from '../../../components/MappingSexList'
import { SearchOptions } from '../../../components/TableHelper'
import { MappingSexConsumer } from '../../../context/MappingSexContext'

type MappingSexProps = {
  filters: any | null,
  history: any,
  permissions: any,

  onLoad?: (searchOptions: SearchOptions) => void
}

export default class MappingSex extends Component<MappingSexProps> {

  handleOnLoad = (searchOptions: SearchOptions) => {
    if (this.props.onLoad) {
      this.props.onLoad(searchOptions)
    }
  }

  render() {
    const { permissions, filters, history } = this.props

    return (
      <MappingSexConsumer>
        {({ fetching, mappingSexs, pagination, requestMappingSexList }) => {

          return <MappingSexList permissions={permissions} loading={fetching} mappingSexs={mappingSexs} pagination={pagination} filters={filters} history={history} onLoad={this.handleOnLoad} loadMappingSexs={requestMappingSexList} />
        }}
      </MappingSexConsumer>
    )
  }
}
